<template>
    <div class="layout-sheet best-seller-sheet-layout" :class="{'no-padding-top' : (bestSellerFinitions.length<2) }">
        <layout-part-sheet-header :product-datas="productDatas" :is-best-seller="true" :best-seller-finitions="bestSellerFinitions"  />
        <trigger-btn-standard />
        <slot></slot>
    </div>
</template>

<script>
    import LayoutPartSheetHeader from "@/components/LayoutPart/LayoutPartSheetHeader";
    import TriggerBtnStandard from "@/components/TriggerBtn/TriggerBtnStandard";

    export default {
        name: 'BestSellerLayout',
        components: {
            LayoutPartSheetHeader,
            TriggerBtnStandard
        },
        props: {
            productDatas: {
                type: Object,
                required: true
            },
            bestSellerFinitions: {
                type: Array,
                default: () => []
            },
        },
    };
</script>

<style lang="scss">
    .layout-sheet {
        &.best-seller-sheet-layout {
            overflow-x: hidden;
        }
      &.no-padding-top {
        padding-top:calc(25px + 60px);

        .sheet-navigation {
          display:none
        }
      }
    }
</style>